import postdocs from './postdocs.json';
import students from './students.json';
import { useState, useEffect } from 'react';

function Students(){
    const [postDocData, setPostDocData] = useState([]);
    const [studentData, setStudentData] = useState([]);

    useEffect(() => {
        setPostDocData(postdocs.map(d => {
            return (
                <li>{d.name}({d.years}) <a target='_blank' href={`${d.arxivLink}`}>See Articles on Arxiv</a></li>
            )
        }));

        setStudentData(students.map(d => {
            return (
                <li>{d.name}(Ph.D. Thesis, Title: {d.title} - {d.year}) </li>
            )
        }))
    }, []);

    return (
        <>
            <h4>Post-Doctoral Researchers</h4>
            <ul>
                {postDocData}
            </ul>
            <h4>Graduate Students</h4>
            <ul>
                {studentData}
            </ul>
        </>
    );
}

export default Students;